export enum TriggerType {
  ATLASSIAN_WEBHOOK_TRIGGER_TYPE = "ATLASSIAN_WEBHOOK_TRIGGER_TYPE",
  CUSTOM_WEBHOOK_TRIGGER_TYPE = "CUSTOM_WEBHOOK_TRIGGER_TYPE",
  SCHEDULED_TRIGGER_TYPE = "SCHEDULED_TRIGGER_TYPE",
  JWT_WEBHOOK_TRIGGER_TYPE = "JWT_WEBHOOK_TRIGGER_TYPE",
  LOG_TRIGGER_TYPE = "LOG_TRIGGER_TYPE"

}
